export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { toolbarBtnThemePageCode, refs, commands, label, pfx } = opts;
  let timedInterval;
  domc.addType('script', {
    view: {
      onRender() {
        const isCC = this.model.closestType(refs.themePageRef);
        isCC && (this.el.innerHTML = '');
      },
    },
  });

  domc.addType(refs.themePageRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: label,
          editable: true,
          projectId: opts.projectId,
          ...opts.propsPreBuiltSectionCode,
        },

        init() {
          this.listenTo(
            this,
            `change:${refs.keyMarketPlaceCustomCode}`,
            this.onThemePageCodeChange,
          );
          const initialCode = this.get(refs.keyMarketPlaceCustomCode) || opts.placeholderContent;
          !this.components().length && this.components(initialCode);
        },

        onThemePageCodeChange() {
          this.components(this.get(refs.keyMarketPlaceCustomCode));
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === refs.themePageRef) {
            return {
              type: refs.themePageRef,
            };
          }
        },
      },
    ),

    view: defaultType.view.extend({
      init() {
        this.listenTo(this.model.components(), 'add remove reset', this.onComponentsChange);
        this.onComponentsChange();
      },

      onComponentsChange() {
        timedInterval && clearInterval(timedInterval);
        timedInterval = setTimeout(() => {
          const { model } = this;
          const content = model.get(refs.keyMarketPlaceCustomCode) || '';
          let droppable = 1;
          if (content.indexOf('<script') >= 0) {
            this.el.innerHTML = opts.placeholderScript;
            droppable = 0;
          }

          model.set({ droppable });
        }, 0);
      },

      onActive() {
        const target = this.model;
        this.em.get('Commands').run(commands.theme_page_custom_code, { target });
      },
    }),
  });
}
